import { WalletCashOut } from '@components';

import './style.scss';

export function WalletCashOutPage() {
  return (
    <div className="wallet-cash-out-page">
      <WalletCashOut />
    </div>
  );
}
